/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { FC } from "react";
import {
  createDeclineButtonId,
  createSaveButtonId,
} from "src/components/molecules/FileList/utils";
import { TableRow } from "src/requests/table/types";
import { ThemedCssCreator } from "../../../../../config/emotion";
import { ButtonType } from "../../../../../globalTypes";
import EwaButton2 from "../../../../atoms/inputs/EwaButtons/EwaButton/EwaButton2";

export type Props = {
  onSubmit: () => void;
  onCancel: () => void;
  acceptButtonType?: ButtonType;
  tableRow: TableRow;
};

const containerCss = css`
  margin-top: 10px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
`;

const buttonContainerCss = css`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

export const cancelButtonCss: ThemedCssCreator = (theme) => css`
  width: 40px;
  height: 40px;
  background-color: ${theme.colors.delete};
`;

export const acceptButtonCss: ThemedCssCreator = (theme) => css`
  width: 40px;
  height: 40px;
  background-color: ${theme.colors.save};
`;

const EditRowSubmitButtons: FC<Props> = ({
  onSubmit,
  onCancel,
  acceptButtonType = ButtonType.Button,
  tableRow,
}) => {
  const { templateId, hash } = tableRow;
  return (
    <div css={containerCss}>
      <div css={buttonContainerCss}>
        <EwaButton2
          iconName="clear"
          onClick={onCancel}
          css={cancelButtonCss}
          id={createDeclineButtonId(templateId, hash)}
        />
      </div>
      <div css={buttonContainerCss}>
        <EwaButton2
          iconName="check"
          onClick={onSubmit}
          css={acceptButtonCss}
          type={acceptButtonType}
          id={createSaveButtonId(templateId, hash)}
        />
      </div>
    </div>
  );
};

export default EditRowSubmitButtons;
export type EditRowSubmitButtonsProps = Props;
